let $btn;
let $counter;

function cacheDOM() {
  $btn = document.querySelector('.js-basket-btn');
  if ($btn) {
    $counter = $btn.querySelector('.js-basket-btn__counter');
  }
}

function handleBasketUpdates() {
  const basket = window?.Rebuy?.Cart?.cart;
  if (!basket) return;

  const itemCount = basket.item_count ?? 0;
  if (itemCount > 0 && itemCount <= 99) {
    $btn.classList.add('header-site__btn--has-items');
    $counter.innerText = itemCount;
  } else if (itemCount > 99) {
    $btn.classList.add('header-site__btn--has-items');
    $counter.innerHtml = '99<sup>+</sup>';
  } else {
    $btn.classList.remove('header-site__btn--has-items');
    $counter.innerText = 0;
  }
}

export default function init() {
  cacheDOM();
  if ($btn && $counter) {
    document.addEventListener('rebuy:cart.change', handleBasketUpdates);
  }
}
